import * as types from './mutationsTypes'

const initialState = {
  user: {},
  usersRelated: {},
  actions: {},
  jwt: '',
  checkUserEmployee: false,
  // loadingStatus: false,
  timerSweetAlert: 1200,
  stateNotOnboarding: false,
  locale: '(ES) Español',
  documentsFiltersFolders: [],
  documentsFiltersDate: {
    from: '',
    to: ''
  },
  userDocumentsTotal: [],
  userFoldersDocuments: [],
  unsignedTotalDocsLength: 0,
  avatarImage: '',
  goBackCameraHandler: true,
  company: {
    logo: ''
  },
  companyLoginUrl: '',
  linkKeycloakResult: null
}

// const initialState = JSON.parse(JSON.stringify(store.state))

export default {
  // SET_SEARCH_EMPLOYEE_RRHH: (state, payload) => {
  //     state.search = payload.search
  // },
  SET_USER: (state, payload) => {
    state.user = payload.user
  },
  SET_CHECK_EMPLOYEE: (state, payload) => {
    state.checkUserEmployee = payload
  },
  SET_USERS_RELATED: (state, payload) => {
    state.usersRelated = payload.usersRelated
  },
  SET_ACTIONS: (state, payload) => {
    state.actions = payload.actions
  },
  SET_PROFILE: (state, payload) => {
    state.profile = payload.profile
  },
  SET_CONFIG: (state, payload) => {
    state.config = payload.config
  },
  SET_JWT: (state, payload) => {
    state.jwt = payload.jwt
    localStorage.setItem('jwt', payload.jwt)
  },
  SET_COMPANY_LOGIN_URL: (state, payload) => {
    state.companyLoginUrl = payload
  },
  SET_LOCALE: (state, payload) => {
    state.locale = payload
  },
  CLEAR_STATE: () => {},
  SET_STATE_NOT_ONBOARDING: (state, payload) => {
    state.stateNotOnboarding = payload
  },
  SET_DOCUMENTS_FILTERS_FOLDERS: (state, payload) => {
    state.documentsFiltersFolders = payload
  },
  SET_DOCUMENTS_FILTERS_DATE: (state, payload) => {
    state.documentsFiltersDate = payload
  },
  SET_USER_DOCUMENTS_TOTAL: (state, payload) => {
    state.userDocumentsTotal = payload
  },
  SET_USER_FOLDERS_DOCUMENTS: (state, payload) => {
    state.userFoldersDocuments = payload
  },
  SET_UNSIGNED_TOTAL_DOCS_LENGTH: (state, payload) => {
    state.unsignedTotalDocsLength = payload
  },
  SET_AVATAR_HEADER: (state, payload) => {
    state.avatarImage = payload
  },
  SET_PREVROUTE: (state, payload) => {
    state.prevRoute = payload
  },
  SET_HAS_INTEGRATION_SICHERN_PEOPLE: (state, payload) => {
    state.hasIntegrationSichernPeople = payload
  },
  SET_HAS_INTEGRATION_SICHERN_CONNECT: (state, payload) => {
    state.hasIntegrationSichernConnect = payload
  },
  CLEAR_USER_DOCUMENTS: (state, payload) => {
    state.userDocumentsTotal = initialState.userDocumentsTotal
    state.userFoldersDocuments = initialState.userFoldersDocuments
    state.unsignedTotalDocsLength = 0
  },
  SET_IS_MANAGER_ROLE: (state, payload) => {
    state.isManagerRole = payload
  },
  CLEAR_AVATAR_HEADER: (state, payload) => {
    state.avatarImage = ''
  },
  CLEAR_PROFILE:(state)  => {
    state.profile = {}
  },
  CLEAR_CANDIDATES:(state)  => {
    state.linkUserMergeCandidates = []
    state.usersRelated = []
  },
  GO_BACK_CAMERA_HANDLER: (state, payload) => {
    state.goBackCameraHandler = payload
  },
  [types.SET_LOGO_COMPANY](state, payload) {
    state.company.logo = payload
  },
  [types.SET_NEW_EMAIL](state, payload) {
    state.user.mail = payload
  },
  SET_AI_TERMS_AND_CONDITIONS: (state, payload) =>{
    state.hasAcceptedAITermsAndConditions = payload
  },
  SET_LINK_USER_MERGE_CANDIDATES: (state, payload) => {
    state.linkUserMergeCandidates = payload
  },
  SET_PAYROLL_STATUS: (state, payload) => { 
    state.payrollStatus = payload
  },
  SET_LINK_KEYCLOAK_RESULT: (state, payload) => {
    state.linkKeycloakResult = payload
  },
  CLEAR_LINK_KEYCLOAK_RESULT: (state) => {
    state.linkKeycloakResult = null
  },
  SET_MANAGER_TASKS_PENDING: (state, payload) => { 
    state.managerTasksPending = payload
  }
}
